import {Component, HostListener, inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {faTriangleExclamation, faFloppyDisk} from "@fortawesome/free-solid-svg-icons";
import {RoleService} from "../../../data-access/role.service";
import {PermissionModel} from "../../../data-access/permission.model";
import {RoleModel} from "../../../data-access/role.model";
import {SubjectsModel} from "../../../data-access/subjects.model";
import {UnitsModel} from "../../../data-access/units.model";
import {ComponentCanDeactivate} from "../../../../exam/utils/pending-changes.guard";
import {Observable, of, switchMap} from "rxjs";
import {
  ConfirmDialogComponent,
  DIALOG_ACTION_STYLE
} from "../../../../shared/ui/confirm-dialog/confirm-dialog.component";
import {FormControl, FormGroup} from "@angular/forms";
import {Dialog} from "@angular/cdk/dialog";
import {Location} from "@angular/common";
import {MatSnackBar} from "@angular/material/snack-bar";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";
import {APIResponse} from "../../../../shared/data-access/api-response.model";
interface PermissionResponse {
  name: string
  permission_id: string
}
interface SubjectResponse {
  subject_name: string
  subject_id: string
  units: UnitResponse[]
}
interface UnitResponse {
  unit_name: string
  unit_id: string
}
interface OrgResponse {
  name: string
  organization_id: number
}
@Component({
    selector: 'userRoleAddEdit',
    templateUrl: './userRoleAddEdit.html',
    styleUrls: ['userRoleAddEdit.css'],
    standalone: false
})
export class UserRoleAddEditComponent implements ComponentCanDeactivate, OnInit {

  add = true;
  openSaveDialog = false;
  titleValidation = false;
  checkPermission = false;
  exitRoleRoute = '';
  faTriangleExclamation = faTriangleExclamation;
  permissionList: PermissionModel[] = [];
  addedPermissions: PermissionModel[] = [];
  unitList: UnitsModel[] = [];
  addedUnits: UnitsModel[] = []
  subjectList: SubjectsModel[] = [];
  addedSubjects: SubjectsModel[] = [];
  orgList: OrgResponse[] = []
  addedOrgList: OrgResponse[] = []
  roleID?: number;
  editRole: RoleModel = {
    role_id: '',
    name: '',
    description: '',
    permissions: []
  };
  primaryColor = `color: ${localStorage.getItem('primaryColor')};`
  saveClick = false
  dialog = inject(Dialog);
  _location = inject(Location)
  roleForm = new FormGroup({
    title: new FormControl(null),
    description: new FormControl(null),
    permissions: new FormControl(this.addedPermissions),
    subjects: new FormControl(this.addedSubjects),
    units: new FormControl(this.addedUnits)
  })
  breadcrumbEndText = ''
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'User Management',
    route: 'dashboard/UserManagement'
  }, {
    text: 'User Roles',
    route: 'dashboard/UserManagement/UserRoles'
  }]
  constructor(
    private router: Router,
    private roleService: RoleService,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar
  ) {}
  ngOnInit() {
    this.add = window.location.pathname.includes('Add')
    if(this.add)
      this.breadcrumbEndText = 'New User Role'
    else
      this.breadcrumbEndText = 'Edit User Role'
    if(!this.add){
      this.route.queryParams.subscribe(params => {
        this.roleID = params['id'];
        this.roleService.getRoleDetail(params['id']).subscribe((response) => {
          this.editRole.name = response.result.name
          this.editRole.description = response.result.description
          response.result.permissions.forEach((permission:PermissionResponse) => {
            this.addedPermissions.push({permission_id: permission.permission_id, name: permission.name})
          })
          this.addedOrgList = response.result.organizations
          response.result.subjects.forEach((subject:SubjectsModel) => {
            this.addedSubjects.push({name: subject.name, subject_id: subject.subject_id})
          })
          response.result.units.forEach((unit:UnitsModel) => {
            this.addedUnits.push({name: unit.name, unit_id: unit.unit_id})
          })
        })
      })
    }
    this.roleService.listAllPermissions().subscribe((response) => {
      for(let permission of response.result) {
        if(!this.addedPermissions.some(el => el.permission_id.toString() === permission.permission_id.toString())) {
          this.permissionList.push(permission);
        }
      }
    })
    this.roleService.listAllSubjectAndUnits().subscribe((response) => {
      if(response.success) {
        this.subjectList = response.result.subjects
        this.unitList = response.result.units
        this.orgList = response.result.organizations
      }
    })
  }

  userManagementMenu() {
    this.router.navigate(['dashboard/UserManagement'])
  }

  userRolesList() {
    this.router.navigate(['dashboard/UserManagement/UserRoles'])
  }

  //TODO should add cookies so that if page is refreshed the added items are not lost, same with the other information on this page
  exitRole() {
    this.router.navigate([this.exitRoleRoute]);
  }

  closeSaveDialog() {
    this.openSaveDialog = false;
  }

  saveRoleDialog() {
    // TODO check if at least one org, subject, or unit is selected before saving role
    this.checkPermission = true
    const title: HTMLInputElement = document.getElementById('title') as HTMLInputElement;
    const description: HTMLInputElement = document.getElementById('description') as HTMLInputElement;
    if(title.value === "") {
      this.titleValidation = true
    }
    if(this.addedPermissions.length !== 0 && !this.titleValidation) {
      this.saveClick = true
      let permissionIDs: string[] = []
      let subjectIDs: string[] = []
      let unitIDs: string[] = []
      let orgIDs: string[] = []

      for(let permission of this.addedPermissions)
        permissionIDs.push(permission.permission_id)

      for(let subject of this.addedSubjects)
        subjectIDs.push(subject.subject_id)

      for(let unit of this.addedUnits)
        unitIDs.push(unit.unit_id)

      for(let org of this.addedOrgList)
        orgIDs.push(org.organization_id.toString())
      if(subjectIDs.length > 0 || unitIDs.length > 0 || orgIDs.length > 0) {
        if(this.add) {
          this.roleService.createRole(title.value, description.value, permissionIDs, orgIDs, subjectIDs, unitIDs).subscribe((response) => {
            this.handleUpdateRole(response)
          })
        }
        else {
          if(this.roleID != null)
            this.roleService.updateRole(title.value, description.value, permissionIDs, orgIDs, subjectIDs, unitIDs, this.roleID.toString()).subscribe((response) => {
              this.handleUpdateRole(response)
            })
        }
      }
    }
  }

  handleUpdateRole(response: APIResponse) {
    if(response.success) {
      this._snackBar.open('Role successfully saved', 'Dismiss', {duration: 3000})
      this.router.navigate(['dashboard/UserManagement/UserRoles']);
    } else {
      this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
    }
  }

  removeItemFromList(item: any, list: any[]) {
    this.roleForm.markAsDirty()
    return list.filter(e => e.name !== item.name);
  }

  canDeactivate(): Observable<boolean> {
    if (this.roleForm.dirty && !this.saveClick) {
      const dialogRef = this.dialog.open<string>(ConfirmDialogComponent, {
        data: {
          title: 'Sure you want to leave?',
          message: `Are you sure you want to leave ${this.add? 'creating': 'editing'} this role? Your changes are not saved.`,
          button_actions: [
            {
              label: 'Yes, leave',
              style: DIALOG_ACTION_STYLE.PRIMARY,
              action: () => 'Confirm',
            },
            {
              label: "Cancel",
              style: DIALOG_ACTION_STYLE.DEFAULT,
              action: () => 'Cancel',
            },
          ],
        },
      });

      return dialogRef.closed.pipe(
        switchMap((result) => {
          if (result === 'Confirm') {
            return of(true);
          }
          return of(false);
        })
      );
    }
    return of(true)
  }

  @HostListener('window:beforeunload')
  unloadHandler() {
    if (this.roleForm.dirty) {
      return false;
    }
    return true;
  }
}
